import Filter from "../../../Filters/Filters";
import InputText from "../../../../../TextInput/TextInput";
import { RoundedButton } from "../../../../../../button";
import { FiltersContainer, FiltersContent } from "./FiltersTab.styled";
import { CurrentFilterEnum } from "../../../../../../../utils/enums";

const FiltersTab = ({
  filters,
  setters,
  isLoading,
  handleTextSearchDebounced,
  handleClearAllFilters,
  searchText,
  setCurrentFilter,
}) => {
  return (
    <FiltersContainer>
      <InputText
        placeholder="Search"
        value={searchText}
        onChange={handleTextSearchDebounced}
        disabled={isLoading}
      />
      <FiltersContent>
        <Filter
          value={filters.selectedMake}
          setValue={(event) => {
            const values = event.target.value;

            setters.setFiltersData.setModels([]);
            setters.setFiltersData.setYears([]);

            const isModelType = values.length ? CurrentFilterEnum.MODEL : CurrentFilterEnum.MAKE;
            setCurrentFilter(isModelType);

            setters.setMake(values);
            setters.setModel([]);
            setters.setYear([]);
            
          }}
          data={filters.make}
          name="Make"
          disabled={isLoading || !filters.make?.length}
        />
        <Filter
          value={filters.selectedModel}
          setValue={(event) => {
            const values = event.target.value;

            setters.setFiltersData.setYears([]);
            
            const isYearType = values.length ? CurrentFilterEnum.YEAR : CurrentFilterEnum.MODEL;
            setCurrentFilter(isYearType);

            setters.setModel(values);
            setters.setYear([]);
          }}
          data={filters.models}
          name="Model"
          disabled={isLoading || !filters.models?.length}
        />
        <Filter
          value={filters.selectedYear}
          setValue={(event) => {
            setters.setYear(event.target.value);
          }}
          data={filters.years}
          name="Year"
          disabled={isLoading || !filters.years?.length}
        />
        <Filter
          value={filters.selectedType}
          setValue={(event) => {
            setters.setType(event.target.value);
          }}
          data={filters.types}
          name="Type"
          disabled={isLoading || !filters.types?.length}
        />
        <Filter
          value={filters.selectedAngle}
          setValue={(event) => {
            setters.setAngle(event.target.value);
          }}
          data={filters.angles}
          name="Angle"
          disabled={isLoading || !filters.angles?.length}
        />
        <Filter
          value={filters.selectedBackground}
          setValue={(event) => {
            setters.setBackground(event.target.value);
          }}
          data={filters.backgrounds}
          name="Background"
          disabled={isLoading || !filters.backgrounds?.length}
        />
        <Filter
          value={filters.selectedSize}
          setValue={(event) => {
            setters.setSize(event.target.value);
          }}
          data={filters.sizes}
          name="Size"
          disabled={isLoading || !filters.sizes?.length}
        />

        <RoundedButton
          onClick={handleClearAllFilters}
          width={"10%"}
          kind="blue"
          outline={true}
          disabled={isLoading}
        >
          Clear all
        </RoundedButton>
      </FiltersContent>
    </FiltersContainer>
  );
};

export default FiltersTab;
